import apiClient from './api.service';

const AuthService = {
  // Admin login
  login(credentials) {
    return apiClient.post('/auth/admin/login', credentials);
  },

  // Logout
  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('adminUser');
  },

  // Get current user info
  getCurrentUser() {
    const userStr = localStorage.getItem('adminUser');
    return userStr ? JSON.parse(userStr) : null;
  },

  // Check if user is authenticated
  isAuthenticated() {
    const token = localStorage.getItem('token');
    return !!token;
  },

  // Get auth token
  getToken() {
    return localStorage.getItem('token');
  },

  // Save auth data
  saveAuthData(token, user) {
    localStorage.setItem('token', token);
    localStorage.setItem('user', user.username || user.email);
    localStorage.setItem('adminUser', JSON.stringify(user));
  },

  // Change password
  changePassword(passwordData) {
    return apiClient.post('/auth/admin/change-password', passwordData);
  }
};

export default AuthService;
